import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01dd2094"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-preview-container" }
const _hoisted_2 = { key: 0 }

import pdfJS from "pdfjs-dist";
import {onMounted, reactive, watch, nextTick, ref, onUnmounted} from "vue";
    
export default /*#__PURE__*/_defineComponent({
  props: {
        /**
         * PDFUrl
         */
        url:{
            type: String,
            required: true
        },
        /**
         * 自定义渲染页数
         */
        renderPages:{
            type: Number,
            default: 100
        },
        /**
         * 自定义减去的高度
         */
        offsetHeight:{
            type: Number,
            default: 0
        }
    },
  setup(__props) {

const props = __props


let divNodes = ref([])
    // 父组件传值
    

    let state = reactive({
        doc: null, // PDF实例
        docPages: 0, // 总页数
        currentPage: 0, // 当前页数
        pageHeight: 0,  // 页面高度
        renderList: [],  // 渲染的列表集合

    })

    /**
     * 监听URl变化
     * @private
     * @returns void
     */
    watch(()=>props.url,(val)=>
    {
        getPDFFile(val);

    },{immediate: true})

    onMounted(()=>
    {
        nextTick(()=>
        {
            document.getElementById("view").setAttribute("content", "width=device-width,initial-scale=1.0");
        })
        // document.addEventListener("scroll", this.scroll.bind(this));
    })

    onUnmounted(()=>
    {
        document.getElementById("view").setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0");
    })
    

    /**
     * 页面滚动事件
     * @private
     * @returns void
     */
    function scroll()
    {
        this.checkRender(document.documentElement);
    }

    /**
     * 获取PDF文件信息
     * @private
     * @returns void
     */
    function getPDFFile(url)
    {
        state.currentPage = 0;
        pdfJS.getDocument({
            url:url,
            // cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.288/cmaps/",//必须引入字体文件
            // cMapUrl: "https://betafile.healthforce.cc/cmaps/",//必须引入字体文件
            cMapUrl: "/cmaps/",//必须引入字体文件
            cMapPacked: true,
        }).then(pdf =>
        {
            state.doc = pdf;
            state.docPages = pdf.numPages;
            nextTick(() =>
            {
                state.docPages && scrollToPage(1);
            });
        });
    }

    /**
     * 跳转到指定页数
     * @private
     * @param {number} pageNo 跳转第几页
     * @returns void
     */
    function scrollToPage(pageNo: number)
    {
        if (state.currentPage === pageNo) return;
        state.currentPage = pageNo;
        let list = [];
        for (let page = pageNo - props.renderPages; page <= pageNo + props.renderPages; page++)
        {
            list.push(page);
        }

        list = list.filter(page => page <= state.docPages && page >= 1);
        nextTick(() =>
        {
            state.renderList = list;
            state.renderList.forEach(page =>
            {
                renderPage(page);
            });
        });
    }

    /**
     * 渲染指定页数数据
     * @private
     * @param {number} pageNo 需要渲染数据
     * @returns void
     */
    function renderPage (pageNo: number)
    {
        state.doc.getPage(pageNo).then(page =>
        {
            let container = divNodes.value[pageNo - 1];
            console.log(container)
            if (!container) return;
            let canvas = container.querySelector("canvas");
            if (!canvas || canvas.__rendered) return;
            let ctx = canvas.getContext("2d");
            let dpr = window.devicePixelRatio || 1;
            let bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
            let ratio = dpr / bsr;
            let rect = container.getBoundingClientRect();
            let viewport = page.getViewport(1);
            let width = rect.width;
            let height = width / viewport.width * viewport.height;
            canvas.style.width = `${width}px`;
            canvas.style.height = `${height}px`;
            state.pageHeight = height;
            canvas.height = height * ratio;
            canvas.width = width * ratio;
            ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
            page.render({
                canvasContext: ctx,
                viewport: page.getViewport(width / viewport.width)
            });
            
            canvas.__rendered = true;
        });
    }

    /**
     * 渲染指定页数数据
     * @private
     * @returns void
     */
    function checkRender (el: HTMLElement) {
        if (!state.pageHeight) return;
        let scrollTop = el.scrollTop;
        if (el === document.documentElement)
        {
            scrollTop = el.scrollTop || window.pageYOffset || document.body.scrollTop;
        }
        let page = Math.floor((scrollTop - props.offsetHeight) / state.pageHeight);
        page = Math.max(page, 1);
        page = Math.min(page, state.docPages);
        scrollToPage(page);
    }
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).docPages, (page, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "page-container container",
        ref: el=>{_unref(divNodes)[index] = el},
        style: _normalizeStyle({
        height: `${_unref(state).pageHeight}px`
      }),
        key: page
      }, [
        (_unref(state).renderList.includes(page))
          ? (_openBlock(), _createElementBlock("canvas", _hoisted_2))
          : _createCommentVNode("", true)
      ], 4))
    }), 128))
  ]))
}
}

})